import classNames from 'classnames';

import InfoIcon from '../../images/icon-info-20.svg';

import styles from './GoLocker.module.scss';

/**
 * GoLockerTip — Figma "Callout/Tip" (12233:3338): a one-line reassurance with the
 * 20px info icon on a neutral-50 well.
 */
const GoLockerTip = ({ children, className }) => (
  <div className={classNames(styles.tip, className)}>
    <img src={InfoIcon} alt="" className={styles.tipIcon} width={20} height={20} />
    <p className={styles.tipText}>{children}</p>
  </div>
);

export default GoLockerTip;
